import React, { useRef } from 'react';

/**
 * 抗体亲和力预测上传表单
 * 需要同时上传：重链、轻链、抗原 的序列或结构文件
 * @param {function} onSubmit - 父组件传入的通用任务提交函数
 */
function AntibodyAffinityPredictionModule({ onSubmit }) {
  const heavyRef = useRef();    // 重链文件
  const lightRef = useRef();    // 轻链文件
  const antigenRef = useRef();  // 抗原文件

  // 触发上传
  const handleSubmit = () => {
    const heavyFile   = heavyRef.current.files[0];
    const lightFile   = lightRef.current.files[0];
    const antigenFile = antigenRef.current.files[0];

    if (!heavyFile || !lightFile || !antigenFile) {
      alert('请上传重链、轻链和抗原序列或结构文件');
      return;
    }

    const formData = new FormData();
    formData.append('heavyChainFile', heavyFile);
    formData.append('lightChainFile', lightFile);
    formData.append('antigenFile',    antigenFile);

    // 调用父级的统一任务处理器
    onSubmit('抗体亲和力预测', formData, 'affinity');
  };

  return (
    <div className="flex flex-col h-full">
      <label className="mb-2">重链序列/结构文件</label>
      <input
        type="file"
        ref={heavyRef}
        accept=".fa,.fasta,.pdb,.txt"
        className="form-input"
      />

      <label className="mt-4 mb-2">轻链序列/结构文件</label>
      <input
        type="file"
        ref={lightRef}
        accept=".fa,.fasta,.pdb,.txt"
        className="form-input"
      />

      <label className="mt-4 mb-2">抗原序列/结构文件</label>
      <input
        type="file"
        ref={antigenRef}
        accept=".fa,.fasta,.pdb,.txt"
        className="form-input"
      />

      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">
          提交任务
        </button>
      </div>
    </div>
  );
}

export default AntibodyAffinityPredictionModule;

